var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.082,
    height: 24.082,
    viewBox: "0 0 24.082 24.082",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8231",
    "data-name": "Group 8231",
    transform: "translate(-174.316 -507.317)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_copy",
    "data-name": "vuesax/bulk/copy",
    transform: "translate(-509.684 127.317)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "copy",
    transform: "translate(684 380)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.048,4.917V9.131c0,3.512-1.4,4.917-4.917,4.917H4.917C1.4,14.048,0,12.643,0,9.131V4.917C0,1.4,1.4,0,4.917,0H9.131C12.643,0,14.048,1.4,14.048,4.917Z",
    transform: "translate(2.007 8.027)",
    fill: "#687594"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M9.121,0H4.907C1.445,0,.04,1.375,0,4.766H3.1c4.214,0,6.171,1.957,6.171,6.171v3.1c3.392-.04,4.766-1.445,4.766-4.907V4.917C14.038,1.4,12.633,0,9.121,0Z",
    transform: "translate(8.037 2.007)",
    fill: "#687594",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H24.082V24.082H0Z",
    fill: "none",
    opacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.bff658ac27005587e4a1a9ab779bc4f1.svg";
export { ForwardRef as ReactComponent };